
// Get all Entreprises
export const getEntreprisesStart =()=>({
    type: "GET_ENTREPRISES_START",
});
export const getEntreprisesSuccess =(entreprises)=>({
    type: "GET_ENTREPRISES_SUCCESS",
    payload: entreprises,
});
export const getEntreprisesFailure =(error)=>({
    type: "GET_ENTREPRISES_FAILURE",
    payload: error,
});


// Add one Entreprise
export const addEntrepriseStart =()=>({
    type: "ADD_ENTREPRISE_START",
});
export const addEntrepriseSuccess =(entreprise)=>({
    type: "ADD_ENTREPRISE_SUCCESS",
    payload: entreprise,
});
export const addEntrepriseFailure =(error)=>({
    type: "ADD_ENTREPRISE_FAILURE",
    payload: error,
});

// Update one Entreprise
export const updateEntrepriseStart =()=>({
    type: "UPDATE_ENTREPRISE_START",
});
export const updateEntrepriseSuccess =(entreprise)=>({
    type: "UPDATE_ENTREPRISE_SUCCESS",
    payload: entreprise,
});
export const updateEntrepriseFailure =(error)=>({
    type: "UPDATE_ENTREPRISE_FAILURE",
    payload: error,
});


// Get All entreprises (only id and nom)
export const getEntreprisesMiniSuccess =(entreprises)=>({
    type: "GET_ENTREPRISES_MINI_SUCCESS",
    payload: entreprises,
});



// Activate one entreprise
export const activateEntrepriseStart =()=>({
    type: "ACTIVATE_ENTREPRISE_START",
});
export const activateEntrepriseSuccess =(entreprise)=>({
    type: "ACTIVATE_ENTREPRISE_SUCCESS",
    payload: entreprise,
});
export const activateEntrepriseFailure =(error)=>({
    type: "ACTIVATE_ENTREPRISE_FAILURE",
    payload: error,
});